
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/[title]",
      function () {
        return require("private-next-pages/academy/[title].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/[title]"])
      });
    }
  